<script>
  let {
    value = $bindable(''),
    label,
    error,
    help,
    name,
    placeholder,
    required = false,
    disabled = false,
    rows = 4
  } = $props()
  // Unique per instance: a drawer's fields share names with the page form behind it.
  const uid = $props.id()
  const fieldId = `${name}-${uid}`
</script>

<fieldset class="fieldset">
  <legend class="fieldset-legend">{label}{#if required}<span class="text-error"> *</span>{/if}</legend>
  <textarea
    id={fieldId}
    {name}
    bind:value
    class="textarea w-full"
    class:textarea-error={!!error}
    {placeholder}    {disabled}
    {rows}
  ></textarea>
  {#if help && !error}<p class="label whitespace-normal">{help}</p>{/if}
  {#if error}<p class="text-error text-sm mt-1">{Array.isArray(error) ? error[0] : error}</p>{/if}
</fieldset>
